<template>
  <div class="min-h-screen ml-0 w-full lg:mr-3">
    <div
      class="flex justify-start divide-x-1.5 bg-white mx-3 my-5 items-center"
    >
      <router-link
        :to="{ name: 'tasks', params: { type: tab.route } }"
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{
          'bg-primary text-white': selectedTab == tab.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ tab.name }}
      </router-link>
    </div>
    <MyTasks v-if="selectedTab == 'My Tasks'" :key="mineKey"></MyTasks>
    <TeamTasks v-if="selectedTab == 'Team Tasks'" :key="teamKey"></TeamTasks>
    <Todos v-if="selectedTab == 'Todos'" :key="todos"></Todos>
  </div>
</template>

<script>
import TeamTasks from "@/components/tasks/teamTasks.vue";
import MyTasks from "@/components/tasks/myTasks.vue";
import Todos from "@/components/tasks/todos.vue";

export default {
  name: "tasks",
  components: {
    TeamTasks,
    MyTasks,
    Todos,
  },
  data() {
    return {
      selectedTab: "My Tasks",
      teamKey: 0,
      mineKey: 1,
      todos: 2,
      tabs: [
        {
          name: "My Tasks",
          route: "my-tasks",
        },
        {
          name: "Team Tasks",
          route: "team-tasks",
        },
        {
          name: "Todos",
          route: "todos",
        },
      ],
    };
  },
  created() {
    this.tabs.forEach((tab) => {
      if (tab.route == this.$route.params.type) {
        this.selectedTab = tab.name;
      }
    });
  },
  watch: {
    $route(to) {
      this.tabs.forEach((tab) => {
        if (tab.route == to.params.type) {
          this.selectedTab = tab.name;
        }
      });
      switch (this.selectedTab) {
        case "My Tasks":
          //console.log(this.selectedTab)
          this.mineKey++;
          break;
        case "Team Tasks":
          this.teamKey++;
          break;
        case "Todos":
          this.todos++;
          break;
      }
    },
  },
  methods: {},
};
</script>
